import React from 'react';
import './App.css';
import styled from 'styled-components';
import Login from './components/Login';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import NotFound from './components/NotFound';
import ScoreDetail from './components/ScoreDetail';
import LoginByMobile from './components/LoginByMobile';
import CustomerRepresenter from './components/CustomerRepresenter';
import MerchantMap from './components/MerchantMap';
import UserProfile from './components/UserProfile';
import MerchantLotteries from './components/MerchantLotteries';
import ChangePassword from './components/ChangePassword';
import CustomerRepresenterAdd from './components/CustomerRepresenterAdd';
import CustomerAddToolsSerial from './components/CustomerAddToolsSerial';
import SupportSystemTicketing from './components/SupportSystemTicketing';
import Lotteries from './components/Lotteries';
import WheelContainer from './components/Wheel/WheelContainer';
import CustomerCheckSerialNumber from './components/CustomerCheckSerialNumber';
import AddGiftCard from './components/AddGiftCard';

function App() {
  return (<Container>
    <Router>
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/loginByMobile" component={LoginByMobile} />
        <Route exact path="/scoredetail" component={ScoreDetail} />
        <Route exact path="/customerrepresenter" component={CustomerRepresenter} />
        <Route exact path="/customerrepresenteradd" component={CustomerRepresenterAdd} />
        <Route exact path="/customeraddtoolsserial" component={CustomerAddToolsSerial} />
        <Route exact path="/supportsystemticketing" component={SupportSystemTicketing} />
        <Route exact path="/merchantmap" component={MerchantMap} />
        <Route exact path="/userprofile" component={UserProfile} />
        <Route exact path="/merchantlotteries" component={MerchantLotteries} />
        <Route exact path="/changepassword" component={ChangePassword} />
        <Route exact path="/lotteries" component={Lotteries} />
        <Route exact path="/wheel" component={WheelContainer} />
        <Route exact path="/checkSerialNumber" component={CustomerCheckSerialNumber} />
        <Route exact path="/addgiftcard" component={AddGiftCard} />
        {/*<Route exact path="/merchantlotterydetail/:id" component={MerchantLotteryDetail} />*/}
        <Route component={NotFound} />
      </Switch>
    </Router>
  </Container>);
}

const Container = styled.div`
  display:flex;
  height:97vh;
  /* background:linear-gradient(to top right,#fba97f96 0%,#db572696 70%); */
  background:linear-gradient(to top right, #6E71e2 0%, #2E3192 70%);
  border-radius:2rem;
  direction: rtl;
  @media screen and (min-width: 320px) and (max-width: 1080px){
    flex-direction: column;  
    display:flex;
    height: max-content;
    min-height:97vh;
    background:linear-gradient(to top right, #6E71e2 0%, #2E3192 70%);
    border-radius:2rem;
    direction: rtl;
  }
  `;

export default App;